'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { visuallyHidden } from "../../styles/index.js";
import styled from "../../styled-components.js";
var VisuallyHiddenElement = styled(/*#__PURE__*/React.forwardRef(function VisuallyHiddenElement(_ref, ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'span' : _ref$component,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "VisuallyHidden__VisuallyHiddenElement",
  componentId: "sc-17bibe8-0"
})(["", ""], visuallyHidden());

/**
 * VisuallyHidden is a component that hides content visually but leaves it available to screen readers.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-visuallyhidden--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/VisuallyHidden)
 */
export var VisuallyHidden = /*#__PURE__*/React.forwardRef(function VisuallyHidden(props, ref) {
  return /*#__PURE__*/React.createElement(VisuallyHiddenElement, Object.assign({}, props, {
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.VisuallyHidden
  }));
});